import React, { useEffect, useMemo, useState } from 'react'
import CallSummary from './CallSummary'
import { Card, CardBody, Col, Container, FormGroup, Input, Row, UncontrolledTooltip } from 'reactstrap'
import { AppConfiguration } from 'config'
import { MetaTags } from 'react-meta-tags'
import Breadcrumb from 'components/Common/Breadcrumb'
import { getCurrentBrandFromLocalStorage, getIANATimezoneStringForAbbreviation, printNameOrEmail } from 'helpers/sf_utils'
import { useDispatch, useSelector } from 'react-redux'
import { getCalls } from 'store/calls/actions'
import ReactAudioPlayer from 'react-audio-player'
import { CALLS_STATUS_OPTIONS, FILTER_COMPONENT_TYPES, LEAD_TYPES_OPTIONS, NO_DATA_MESSAGE, PRODUCT_TYPE_IDS, REPORTING_TIMEZONE, REQUIRED_FEATURE_FLAGS, YesNoOptionsWithBooleanValues, convertStringifiedNullToNull, getLeadTypeById } from 'helpers/sf_constants'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import _, { capitalize } from 'lodash'
import { format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import { phoneNumberFormatter } from 'pages/Admin/Users/UserComponents/UserList/Formatters'
import { getCampaignOptions, timeFormatter } from 'helpers/sf_dashboard_helper'
import SfLoadingSkeleton from 'components/Common/Loadings/SfLoadingSkeleton'
import { CALL_STATUS_OPTIONS, NEW_CALL_STATUS_OPTIONS, PROSPECT_FILTERED_COLUMNS_NAMES, PROSPECT_FILTERED_COLUMNS_OBJECTS, PROSPECT_FILTERED_COLUMN_RTB } from 'helpers/CustomFilters/prospect_filter_helper'
import useAccountCampaigns from 'hooks/useAccountCampaigns'
import { usStatesOptions } from 'common/data/us_states'
import ShowAppliedFilters from 'components/Common/CustomFilters/ShowAppliedFilters'
import CustomProspectFilters from "components/Common/CustomFilters";
import { isGoalBrand } from 'config'
import { getProspects } from 'store/prospects/actions'
import { handlePdfExport, mapActiveFilters, mapActiveFiltersForProspect } from 'helpers/conversation_filter_helper'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useNewBrandUI from 'hooks/useNewBrandUI'
import useBrandList from 'hooks/useBrandList'


const selectedTagItems = [PROSPECT_FILTERED_COLUMNS_NAMES.CALL_DURATION, PROSPECT_FILTERED_COLUMNS_NAMES.VEHICLES, PROSPECT_FILTERED_COLUMNS_NAMES.DRIVERS];

const Conversations = () => {
    const show_rtb_brand_ui_changes = useNewBrandUI()
    const filtersList = show_rtb_brand_ui_changes ? { ...PROSPECT_FILTERED_COLUMNS_OBJECTS, ...PROSPECT_FILTERED_COLUMN_RTB } : PROSPECT_FILTERED_COLUMNS_OBJECTS;
    const cloned_prev_items = _.cloneDeep(filtersList)
    const dispatch = useDispatch()
    const [isFeatureFlagActive] = useFeatureFlags();

    const { calls, call_summary_loading, call_data_loading, current_brand, prospects, prospects_loading, call_summary, answer_to_query_loading } = useSelector((state) => ({
        calls: state.Calls.calls,
        prospects: state.Prospects.leads,
        call_summary_loading: state.CallSummary.call_summary_loading,
        call_data_loading: state.Calls.loading,
        current_brand: state.Brands.current_brand,
        prospects_loading: state.Prospects.loading,
        call_summary: state.CallSummary.call_summary,
        answer_to_query_loading: state.AnswerFromQuery.answer_to_query_loading,
    }))

    const [callIds, setCallIds] = useState([]);
    const [callDetails, setCallDetails] = useState([])
    const [isActiveFilterModal, setIsActiveFilterModal] = useState(false);
    const [_unscoped_account_campaigns, account_campaigns] = useAccountCampaigns();
    const [prospectFilterItems, setProspectFilterItems] = useState([]);
    const [selectedProspectName, setSelectedProspectName] = useState('');
    const [callIdIndex, setCallIdIndex] = useState(0)
    const [overallConversation, setOverallConversation] = useState()

    const [filterModal, setFilterModal] = useState({

        first_name: false,
        first_name_value: "",

        last_name: false,
        last_name_value: "",

        phone_num: false,
        phone_num_value: "",

        email: false,
        email_value: "",

        state: false,
        state_value: null,

        campaign_name: false,
        campaign_name_value: "",

        lead_type: false,
        lead_type_value: "",

        status: false,
        status_value: null,

        received: false,
        received_value: "",

        insured: false,
        insured_value: "",

        city: false,
        city_value: "",

        address: false,
        address_value: "",

        zip_code: false,
        zip_code_value: "",

        vehicles: false,
        vehicles_value: "",

        call_duration: false,
        call_duration_value: "",

        cost: false,
        cost_value: "",

        refund_status: false,
        refund_status_value: "",

        profile: false,
        profile_value: "",

        transfer_type: false,
        transfer_type_value: "",

        recording: false,
        recording_value: "",

        drivers: false,
        drivers_value: "",

        brand_name: false,
        brand_name_value: "",
    });

    const queryParams = {};

    const getDetails = isGoalBrand ? getProspects : getCalls

    const selectedDetails = isGoalBrand ? prospects : calls

    const updatedBrandId = () => {
        let brand_id = show_rtb_brand_ui_changes ? null : current_brand?.id || getCurrentBrandFromLocalStorage()?.id;
        return brand_id
    }

    useEffect(() => {
        dispatch(getDetails({ queryParams: queryParams }))
    }, [dispatch])

    useEffect(() => {
        setCallIds(selectedDetails.filter(call => {
            if (isGoalBrand) {
                return call?.lead_detail?.lead_id !== null && call?.qf_quote_calls?.length;
            } else {
                return call?.lead_id !== null;
            }
        }).map(call => (isGoalBrand ? call?.lead_detail?.lead_id : call?.lead_id)));
    }, [selectedDetails, isGoalBrand]);

    useEffect(() => {
        setCallDetails(selectedDetails.find((call) => (isGoalBrand ? call?.lead_detail?.lead_id : call?.lead_id) === callIds[callIdIndex]));
    }, [callIds, selectedDetails, callIdIndex]);

    useEffect(() => {
        setCallIdIndex(0)
    }, [selectedDetails])

    const handleNextCall = () => {
        if (callIdIndex !== callIds.length - 1) { setCallIdIndex(prevIndex => prevIndex + 1); }
    }
    const handlePrevCall = () => {
        if (callIdIndex !== 0) { setCallIdIndex(prevIndex => prevIndex - 1); }
    }

    const handleSearchProspectName = (e, prospect_name) => {
        //TODO: Handle pagination
        const brandId = updatedBrandId()
        const splitName = prospect_name?.split(" ");
        let firstName = "";
        let lastName = "";

        if (splitName?.length > 2) {
            const nameArray = [...splitName];
            lastName = nameArray.pop();
            firstName = nameArray.join(" ");
        } else if (splitName?.length === 2) {
            [firstName, lastName] = splitName;
        }
        else {
            firstName = prospect_name;
        }
        //creating two query params because the calls filters are based on old appraoch of data filtering and prospects are based on new.
        const queryParams = {
            filters: JSON.stringify({
                first_name: true,
                first_name_value: splitName?.length === 1 ? prospect_name : firstName,
                last_name: splitName?.length > 1 ? true : null,
                last_name_value: splitName?.length > 1 ? lastName : null
            }),
            page_number: 1,
            brand_id: brandId
        };

        const prospectFilterState = [
            {
                name: "first_name",
                comparator_value: "",
                component_type: "text",
                value: firstName
            },
        ];

        const lastNameObject = {
            name: "last_name",
            comparator_value: "",
            component_type: "text",
            value: lastName
        }
        if (lastName?.length) {
            prospectFilterState.push(lastNameObject)
        }
        const prospectQueryParams = {
            filters: JSON.stringify(prospectFilterState),
            page_number: 1,
            brand_id: brandId
        };

        if (!call_data_loading) {
            const params = isGoalBrand ? prospectQueryParams : queryParams;
            dispatch(getDetails({ queryParams: params }, true));
        }
    };

    const campaignOptions = useMemo(() => {
        const campaigns = account_campaigns?.filter(campaign => campaign.product_type_id === (isGoalBrand ? PRODUCT_TYPE_IDS.QUOTE_FUNNELS : PRODUCT_TYPE_IDS.CALLS))
        const campaignOpts = getCampaignOptions(campaigns, show_rtb_brand_ui_changes)
        return campaignOpts;
    }, [account_campaigns, show_rtb_brand_ui_changes]);
    const { brandList } = useBrandList(true);
    const rtb_filter_item = show_rtb_brand_ui_changes && {
        [PROSPECT_FILTERED_COLUMNS_NAMES.BRAND_NAME]: {
            ...cloned_prev_items[PROSPECT_FILTERED_COLUMNS_NAMES.BRAND_NAME],
            options: brandList || []
        },
    }

    const mapped_filter_items = {
        ...cloned_prev_items,
        [PROSPECT_FILTERED_COLUMNS_NAMES.LEAD_TYPE]: {
            ...cloned_prev_items[PROSPECT_FILTERED_COLUMNS_NAMES.LEAD_TYPE],
            options: LEAD_TYPES_OPTIONS
        },
        [PROSPECT_FILTERED_COLUMNS_NAMES.CAMPAIGN_NAME]: {
            ...cloned_prev_items[PROSPECT_FILTERED_COLUMNS_NAMES.CAMPAIGN_NAME],
            options: campaignOptions || []
        },
        [PROSPECT_FILTERED_COLUMNS_NAMES.STATE]: {
            ...cloned_prev_items[PROSPECT_FILTERED_COLUMNS_NAMES.STATE],
            options: usStatesOptions
        },
        [PROSPECT_FILTERED_COLUMNS_NAMES.DISPOSITION]: {
            ...cloned_prev_items[PROSPECT_FILTERED_COLUMNS_NAMES.DISPOSITION],
            options: CALLS_STATUS_OPTIONS
        },
        [PROSPECT_FILTERED_COLUMNS_NAMES.INSURED]: {
            ...cloned_prev_items[PROSPECT_FILTERED_COLUMNS_NAMES.INSURED],
            options: YesNoOptionsWithBooleanValues
        },
        [PROSPECT_FILTERED_COLUMNS_NAMES.CALL_STATUS]: {
            ...cloned_prev_items[PROSPECT_FILTERED_COLUMNS_NAMES.CALL_STATUS],
            options: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_MULTIPLE_CALL_FILTERS) ? NEW_CALL_STATUS_OPTIONS : CALL_STATUS_OPTIONS
        },
        ...rtb_filter_item
    }

    const onClickOpenFilterModal = () => {
        setIsActiveFilterModal(true);
        const mapped_filter_items_arr_objects = Object.values(mapped_filter_items);
        setProspectFilterItems((prev_prospect_filter_items) => {
            const cloned_prev_items = _.cloneDeep(prev_prospect_filter_items)
            const new_mapped_filter_items = mapped_filter_items_arr_objects.map((item) => {
                const active_filters = cloned_prev_items.find(prev_item => prev_item.name === item.name);
                if (active_filters) {
                    return active_filters;
                }
                return item;
            });
            return new_mapped_filter_items;
        });
    }

    const onCloseFilterModal = () => {
        setIsActiveFilterModal(false);
    }

    const onClickLoadMoreData = (prospect_filter_items = null, filterCount = null, last_page_fetched = null) => {
        const active_filtered_columns = { data: null }
        if (prospect_filter_items) {
            active_filtered_columns.data = isGoalBrand ? mapActiveFiltersForProspect(prospect_filter_items) : mapActiveFilters(prospect_filter_items, selectedTagItems)
        }
        fetchNextBatch(filterCount ? active_filtered_columns.data : null, last_page_fetched)
    }

    const onSubmitOpenFilterModal = (values) => {
        const activeFilteredColumns = values.filter(item => {
            if (item.component_type === FILTER_COMPONENT_TYPES.COMPARATOR) {
                return item.is_active && (!!item.value) && (item.comparator_value.trim() !== "");
            }
            return item.is_active && (!!item.value);
        });
        setProspectFilterItems(activeFilteredColumns);
        if (activeFilteredColumns) {
            onClickLoadMoreData(activeFilteredColumns, true);
            onCloseFilterModal();
            return
        }

        fetchNextBatch();
        onCloseFilterModal();
    }

    const onClickRemoveFilter = (field_name) => {
        setProspectFilterItems((prev_prospect_filter_items) => {
            const cloned_prev_items = _.cloneDeep(prev_prospect_filter_items)
            const mapped_filter_items = cloned_prev_items.map((item) => {
                if (item.name !== field_name) {
                    return item;
                }
                return ({ ...item, is_active: false, value: null })
            });
            const filterd_filter_items = (mapped_filter_items || []).filter(item => item.is_active);
            fetchNextBatch(filterd_filter_items)
            return mapped_filter_items;
        });
    }

    const fetchNextBatch = (filterModal = null, last_page_fetched = 0) => {
        if (filterModal) {
            const filterModalData = convertStringifiedNullToNull(filterModal)
            queryParams.filters = JSON.stringify(filterModalData || {})
        }
        queryParams.page_number = last_page_fetched + 1
        queryParams.brand_id = updatedBrandId()
        !call_data_loading && dispatch(getDetails({ queryParams: queryParams }, true));
    }


    const { filterCount, activeProspectFilterItems } = useMemo(() => {
        if (prospectFilterItems?.length) {
            const filtered_active_prospects = prospectFilterItems.filter(item => item.is_active);
            return { filterCount: filtered_active_prospects?.length || 0, activeProspectFilterItems: filtered_active_prospects }
        }
        return ({ filterCount: 0, activeProspectFilterItems: [] });
    }, [prospectFilterItems]);
    // Filter End


    const recordingSrc = isGoalBrand
        ? ((callDetails && callDetails.qf_quote_calls && callDetails.qf_quote_calls.length > 0)
            ? callDetails.qf_quote_calls[0].recording_url
            : null)
        : (callDetails && callDetails.recording_url);


    const callDuration = (callDetails && callDetails.qf_quote_calls && callDetails.qf_quote_calls.length > 0)
        ? (callDetails.qf_quote_calls[0].call_duration)
        : (callDetails && callDetails.call_duration || 0);

    const formattedDuration = timeFormatter(callDuration);

    const prevCallButtonDisabled = callIdIndex === 0 || !callIds.length || call_summary_loading || answer_to_query_loading
    const nextCallButtonDisabled = callIds.length === callIdIndex + 1 || !callIds.length || call_summary_loading || answer_to_query_loading

    return (
        <React.Fragment>
            <div className="page-content" id="page-content-wrapper">
                <MetaTags>
                    <title>Conversations | {AppConfiguration.WEBSITE}</title>
                </MetaTags>
                <Container fluid className='mb-3'>
                    <CustomProspectFilters
                        isActive={isActiveFilterModal}
                        modalState={filterModal}
                        filterItems={prospectFilterItems}
                        onSubmitModalState={onSubmitOpenFilterModal}
                        onClickModalClose={onCloseFilterModal}
                        isActiveSearchBox={false}
                    />
                    <Breadcrumb title="" backOption={false} breadcrumbItem="Conversations" />
                    <Row>
                        <Col lg="12">
                            <Card>
                                <Row className="gap-4">
                                    <Col md={1}>
                                        <FormGroup className="mt-3 mb-0 ms-3">
                                            <div>
                                                <button
                                                    className={`d-flex align-items-center btn btn-outline-primary ${(filterModal?.isActiveModal || filterCount !== 0) ? 'filter-btn' : ''} ${filterCount === 0 ? 'filter-btn-w' : ''}`}
                                                    type='button'
                                                    onClick={() => {
                                                        setSelectedProspectName("");
                                                        onClickOpenFilterModal();
                                                    }}
                                                >
                                                    <i className="bx bx-filter font-size-18 align-middle me-2" />
                                                    Filters {filterCount != 0 && <span className={filterModal?.isActiveModal ?
                                                        'numberCircle' : 'numberCircle border-0'}> {filterCount} </span>}
                                                </button>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md={2} className='align-self-middle ms-4 mt-3'>
                                        <FormGroup className="mb-0">
                                            <div className="search-box me-2 d-inline-block">
                                                <div className="position-relative">
                                                    <Input
                                                        className="rounded sf-box-w"
                                                        value={selectedProspectName}
                                                        placeholder="Search prospect name"
                                                        onChange={(e) => {
                                                            setSelectedProspectName(e.target.value);
                                                        }}

                                                        onKeyPress={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault()
                                                                handleSearchProspectName(e, selectedProspectName)
                                                            }
                                                        }}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={5} className="align-self-center ms-4">
                                        <ShowAppliedFilters filtered_columns={activeProspectFilterItems} onClickRemoveFilter={onClickRemoveFilter} />
                                    </Col>
                                    {
                                        <Col className='d-flex align-items-center justify-content-end me-4' >
                                            <button id="conversations-next-page-button" className={`btn circular-next-button fs-16 me-2`} onClick={handlePrevCall} style={prevCallButtonDisabled ? { cursor: 'not-allowed' } : {}}>
                                                <span className='font-weight-semibold fs-24' style={prevCallButtonDisabled ? { color: 'gray' } : {}}>{"<"}</span>
                                            </button>
                                            {!(call_data_loading || prospects_loading || call_summary_loading) && <UncontrolledTooltip
                                                placement="top"
                                                target="conversations-next-page-button"
                                            >
                                                {prevCallButtonDisabled ? 'No Previous Call' : 'Previous Call'}
                                            </UncontrolledTooltip>
                                            }
                                            <button id="conversations-prev-page-button" className={`btn circular-next-button fs-16`} onClick={handleNextCall} style={nextCallButtonDisabled ? { cursor: 'not-allowed' } : {}}>
                                                <span className='font-weight-semibold fs-24' style={nextCallButtonDisabled ? { color: 'gray' } : {}}>{">"}</span>
                                            </button>
                                            {!(call_data_loading || prospects_loading || call_summary_loading) && <UncontrolledTooltip
                                                placement="top"
                                                target="conversations-prev-page-button"
                                            >
                                                {nextCallButtonDisabled ? 'No Next Call' : 'Next Call'}
                                            </UncontrolledTooltip>
                                            }
                                        </Col>}
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                    <Row style={{ minHeight: '570px' }}>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    {call_data_loading || prospects_loading ?
                                        <SfLoadingSkeleton rows={5} cols={2} />
                                        : callIds?.length ?
                                            (
                                                <Row>
                                                    <Row style={{ borderBottom: '1px solid #eee' }}>
                                                        <Col md={4} className="text-black text-start fs-16 mb-3 fw-bold mt-1 ms-2">
                                                            {printNameOrEmail(callDetails?.lead_detail?.first_name, callDetails?.lead_detail?.last_name, null, '-- --')}
                                                        </Col>
                                                        <Col md={6}>
                                                            <div className="d-flex align-items-center mb-3">
                                                                {(recordingSrc) ?
                                                                    <ReactAudioPlayer
                                                                        src={recordingSrc}
                                                                        style={{ height: '30px', width: '60%' }}
                                                                        controls={true}
                                                                        onPlay={() => { }}
                                                                        onPause={() => { }}
                                                                    />
                                                                    :
                                                                    !call_data_loading && 'No recording available'
                                                                }
                                                            </div>
                                                        </Col>
                                                        <Col md="auto" className="ms-auto align-items-end">
                                                            <div className="mb-2">
                                                                <div>
                                                                    <button className="btn btn-outline-sfblue" onClick={() => handlePdfExport(call_summary, callDetails, overallConversation)}>
                                                                        <i className="bx bx-import font-size-14 align-middle me-2" />
                                                                        Export
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-3" style={{ borderBottom: '1px solid #eee' }}>
                                                        <Col lg="auto" className='ms-2 me-4'>
                                                            <span className="text-black font-weight-semibold">
                                                                Call Received
                                                            </span>
                                                            <p className="text-black">
                                                                {callDetails?.created_at ? format(utcToZonedTime(callDetails?.created_at, getIANATimezoneStringForAbbreviation(REPORTING_TIMEZONE)), 'MM/dd/yyyy hh:mm aa') : ''}
                                                            </p>
                                                        </Col>
                                                        <Col lg="auto" className='ms-3 me-4'>
                                                            <span className="text-black font-weight-semibold">
                                                                Phone
                                                            </span>
                                                            <p className="text-black">
                                                                {phoneNumberFormatter(callDetails?.lead_detail?.phone)}
                                                            </p>
                                                        </Col>
                                                        <Col lg="auto" className='ms-3 me-4'>
                                                            <span className="text-black font-weight-semibold">
                                                                Total Call Duration
                                                            </span>
                                                            <p className="text-black">
                                                                {formattedDuration}
                                                            </p>
                                                        </Col>
                                                        <Col lg="auto" className='ms-3 me-4'>
                                                            <span className="text-black font-weight-semibold">
                                                                Type
                                                            </span>
                                                            <p className="text-black">
                                                                {capitalize(getLeadTypeById(callDetails?.lead_type_id)?.name) || '--'}
                                                            </p>
                                                        </Col>
                                                        <Col lg="auto" className='ms-3 me-4'>
                                                            <span className="text-black font-weight-semibold">
                                                                Campaign
                                                            </span>
                                                            <p className="text-black">
                                                                {callDetails?.campaign?.name}
                                                            </p>
                                                        </Col>
                                                        {show_rtb_brand_ui_changes && <Col lg="auto" className='ms-3 me-4'>
                                                            <span className="text-black font-weight-semibold">
                                                                Brand
                                                            </span>
                                                            <p className="text-black">
                                                                {callDetails?.campaign?.brand?.name}
                                                            </p>
                                                        </Col>}
                                                        <Col lg="auto" className='ms-auto mt-2 '>
                                                            <p className="text-black ms-3 font-weight-semibold">
                                                                <Link to={`/${isGoalBrand ? 'prospects' : 'calls'}/${callDetails?.lead_id || callDetails?.lead_detail?.lead_id}`} className='text-sfblue'>
                                                                    {"Go to Call Details"}
                                                                </Link>
                                                            </p>
                                                        </Col>
                                                    </Row>

                                                </Row>
                                            ) :
                                            <div className='no-summary-message d-flex align-items-center justify-content-center '>{NO_DATA_MESSAGE}</div>}
                                    {callIds.length > 0 &&
                                        <div className='ms-1 mt-2'>
                                            <CallSummary lead_id={callIds[callIdIndex]} setOverallConversation={setOverallConversation} />
                                        </div>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Conversations
